import { atom } from "jotai";

// Define the type for the storno dialog state
export interface StornoDialogState {
  isOpen: boolean;
  offerId: string | null;
}

// Create an atom for the storno dialog state
export const stornoDialogState = atom<StornoDialogState>({
  isOpen: false,
  offerId: null,
});
